import { render, staticRenderFns } from "./all_orders.vue?vue&type=template&id=272ae92a&scoped=true&"
import script from "./all_orders.vue?vue&type=script&lang=js&"
export * from "./all_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ae92a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('272ae92a')) {
      api.createRecord('272ae92a', component.options)
    } else {
      api.reload('272ae92a', component.options)
    }
    module.hot.accept("./all_orders.vue?vue&type=template&id=272ae92a&scoped=true&", function () {
      api.rerender('272ae92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/all_orders.vue"
export default component.exports